import React from 'react';
import { Box, Card, Grid, makeStyles, Typography } from 'housecall-ui';
import CheckIcon from 'housecall-ui/dist/IconsAndImages/Icons/Check';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

import { formatMoney } from '../../utils/formatMoney';

type Props = {
  name: string;
  price: number;
  onClick: (value: boolean) => void;
  value: boolean;
};

type StyleProps = {
  isActive: boolean;
};

const useStyles = makeStyles((theme: HCPTheme) => ({
  card: ({ isActive }: StyleProps) => ({
    border: `1px solid ${isActive ? theme.palette.info.main : 'transparent'}`,
    cursor: 'pointer',
  }),
  nameText: {
    wordBreak: 'break-word',
  },
}));

export const PricingFormMultiSelectOption = ({ name, price, onClick, value }: Props) => {
  const isActive = value;
  const { card, nameText } = useStyles({ isActive });

  return (
    <Grid item xs={12} sm={6}>
      <Card onClick={() => onClick(!value)} className={card}>
        <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box display="flex" justifyContent="center" alignItems="center" mr={1}>
              <CheckIcon color={isActive ? 'primary' : 'disabled'} />
            </Box>
            <Typography
              version="v2"
              variant="subtitle2"
              className={nameText}
              color={isActive ? 'primary' : 'textPrimary'}
            >
              {name}
            </Typography>
          </Box>
          <Typography version="v2" variant="subtitle2" color={isActive ? 'primary' : 'textPrimary'}>
            {formatMoney(price)}
          </Typography>
        </Box>
      </Card>
    </Grid>
  );
};
